<div>
    <h5 mat-dialog-title class="modal_title flex">
        {{ "CAMPAIGN.CHOOSE_YOUR_DATA_SOURCE" | translate }}
        <mat-icon svgIcon="mat_outline:close"
            class="ml-auto max-w-[22px] max-h-[22px] text-[#0b0d13] font-medium cursor-pointer leading-none min-w-[22px] text-[22px] min-h-[22px]"
            mat-dialog-close></mat-icon>
    </h5>
    <mat-dialog-content class="modal_body">
        <div class="flex flex-row">
            <div class="bg-[#F8F8FB] rounded p-[22px] w-[334px]">
                <div class="flex mb-[22px]">
                    <img class="w-[58px] h-[58px] object-cover" [src]="'contacts.png' | imagePath" alt="contact" />
                </div>
                <div class="flex flex-col">
                    <h2 class="font-medium leading-6 text-lg text-[#0B0D13] mb-4">
                        {{ "CAMPAIGN.USE_MY_OWN_CONTACTS" | translate }}
                    </h2>
                    <div class="flex items-center" *ngFor="let contact of contacts?.ownContacts">
                        <div [class]="
                                contact.icon == 'ri-checkbox-circle-fill'
                                    ? 'text-[#0A8F3F]'
                                    : 'text-[#EB4335]'
                            ">
                            <i class="{{ contact.icon }} text-md mr-2.5 "></i>
                        </div>
                        <p class="text-md leading-5 font-normal text-[#0B0D13]">
                            {{ contact.name }}
                        </p>
                    </div>
                    <div class="mt-3 mb-7">
                        <ul class="list-disc ml-5 text-[#0B0D13]">
                            <li class="text-md leading-5 font-normal">
                                <b>{{
                                    "CAMPAIGN.UPLOAD_A_LIST_OF_PROSPECTS"
                                    | translate
                                    }}</b>
                            </li>
                            <li class="text-md leading-5 font-bold">
                                {{
                                "CAMPAIGN.SET_UP_AN_OUTREACH_SEQUENCE"
                                | translate
                                }}
                            </li>
                            <li class="text-md leading-5 font-normal">
                                {{
                                "CAMPAIGN.SCHEDULE_AND_LAUNCH_YOUR_CAMPAIGN"
                                | translate
                                }}
                            </li>
                            <li class="text-md leading-normal text-[#2D3347]">{{"EMAIL_MARKETING.DOWNLOAD" | translate}}
                                <a class="cursor-pointer text-primary"
                                    (click)="downloadFile($event)">{{"EMAIL_MARKETING.SAMPLE_CSV" | translate}}</a>
                                {{"EMAIL_MARKETING.FILE" | translate}}
                            </li>
                        </ul>
                    </div>
                    <div class="mb-1.5">
                        <btn-loading type="submit" color="primary" (click)="selectFile.click()"
                            btnClass="text-md text-custom font-normal leading-[14px] min-h-[38px] max-h-[38px] rounded mr-3"
                            [loading]="mapping?.isLodingMapping">
                            {{ "CAMPAIGN.UPLOAD_CSV_FILE" | translate }}
                        </btn-loading>
                        <input type="file" id="FileUpload" class="hidden" #selectFile
                                (change)="mapping.uploadFile($event)" accept=".csv" />
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</div>
